import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mobile-menu-item',
  template: '<ng-content></ng-content>',
  styleUrls: ['./mobile-menu-item.component.scss']
})
export class MobileMenuItemComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
